import React from 'react';
import MultiCarouselPlaceholderItem from './multi-carousel-placeholder-item';

import './multi-carousel-placeholder.scss';

const MultiCarouselPlaceholder: React.FC<{itemCount: number;}> = ({ itemCount }) => (
    <div className="carousel-placeholder">
        {Array.from(Array(itemCount), (item, key) => <MultiCarouselPlaceholderItem key={key} />)}
    </div>
);

export default MultiCarouselPlaceholder;
